import { Card, CardActionArea, CardContent, Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import classnames from "classnames";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      overflow: "visible",
      borderLeft: `${theme.spacing(1)} solid ${theme.palette.info.light}`,
    },
    content: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: theme.spacing(1),
    },
    countSpan: {
      marginRight: theme.spacing(),
    },
  })
);

interface NotmealOnlyItemProps {
  onClick: () => void;
  className?: string;
  unlinkedCount: number;
  notemealOnlyCount: number;
}

const NotmealOnlyItem = ({ onClick, className, unlinkedCount, notemealOnlyCount }: NotmealOnlyItemProps) => {
  const classes = useStyles();

  return (
    <Card raised className={classnames(className, classes.root)}>
      <CardActionArea onClick={onClick}>
        <CardContent className={classes.content}>
          <div>
            <Typography>Notemeal Only Profiles</Typography>
            <Typography>Use this rule to designate a profile that should not be synced with Teamworks</Typography>
            <Typography variant="body2" color="textSecondary">
              <span className={classes.countSpan}>Unlinked: {unlinkedCount}</span>
              <span className={classes.countSpan}>Notemeal Only: {notemealOnlyCount}</span>
            </Typography>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default NotmealOnlyItem;
